var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconIntelligenceFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 2c1.5 0 1.667 3.667 3 5 1.333 1.333 5 1.5 5 3s-3.667 1.667-5 3c-1.333 1.333-1.5 5-3 5s-1.667-3.667-3-5c-1.333-1.333-5-1.5-5-3s3.667-1.667 5-3c1.333-1.333 1.5-5 3-5Zm6.5-2c.5 0 .584 1.75 1.167 2.333C16.25 2.916 18 3 18 3.5s-1.75.584-2.333 1.167C15.084 5.25 15 7 14.5 7s-.584-1.75-1.167-2.333C12.75 4.084 11 4 11 3.5s1.75-.584 2.333-1.167C13.916 1.75 14 0 14.5 0Z"
})));
export default SvgIconIntelligenceFilled;